// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3098":"40bde2b3","5956":"62f747ca","7095":"f33d3382","7749":"84708f95"}[chunkId] + ".chunk.css";
};